export default "__VITE_ASSET__d83b3611__"